<template>
    <div>
        <div class="table-responsive table-card" :class="showPagination ? ' mb-3' : ' mb-0'">
            <table class="table  align-middle table-nowrap mb-0 table-hover">
                <thead class="table-light">
                <tr>
                    <th
                        v-for="(column, index) in visibleColumns"
                        :key="index"
                        :class="[
                            column.class,
                            column.sortable ? 'sort cursor-pointer user-select-none' : ''
                        ]"
                        @click="column.sortable ? onSort(column.field) : null"
                    >
                        <span
                            :class="[
                                'fw-bold d-block w-100 h-100',
                                column.sortable ? getSortingClass(column.field) : 'text-dark'
                            ]"
                        >
                            {{ column.label }}
                        </span>
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) in data" :key="index">
                    <!--All columns-->
                    <td v-for="(column, colIndex) in visibleColumns" :key="colIndex" :class="column.cellClass ?? column.class">
                        <slot :name="column.slot" :item="item" :index="index" v-if="column.slot" />
                        <span v-else>{{ item.data[column.field] }}</span>
                    </td>
                </tr>
                <!--No records-->
                <tr v-if="!loading && data.length === 0"  class="text-center font-italic text-muted">
                    <td :colspan="visibleColumns.length" v-if="searchLoaded">
                        <lord-icon
                            src="https://cdn.lordicon.com/msoeawqm.json"
                            trigger="loop"
                            colors="primary:#212529,secondary:#3577f1"
                            style="width: 75px; height: 75px;"
                        ></lord-icon>
                        <p class="mt-2 h5">Aucun résultat</p>
                        <p class="text-muted mb-0">Aucune entrée ne correspond à votre recherche</p>

                    </td>
                    <td :colspan="visibleColumns.length" v-else>
                        Aucune entrée
                    </td>
                </tr>
                <!--Loader-->
                <tr v-if="loading">
                    <td :colspan="visibleColumns.length">
                        <loader />
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <pagination
            v-if="showPagination"
            @change-page:clicked="onPageChange"
            :visible="!loading"
            :links="links"
            :meta="meta"
        />
    </div>
</template>

<script setup>
import { computed } from 'vue';
import Loader from "./Loader.vue";
import Pagination from "./Pagination.vue";

const props = defineProps({
    searchLoaded: {
        type: Boolean,
        default: false,
    },
    columns: {
        type: Array,
        required: true,
    },
    data: {
        type: Array,
        required: true,
    },
    loading: {
        type: Boolean,
        default: false,
    },
    links: {
        type: Object,
        default:() => ({}),
    },
    meta: {
        type: Object,
        default: () => ({}),
    },
    sortingField: {
        type: String,
        default: "",
    },
    sortingOrder: {
        type: Object,
        default: () => ({}),
    },
    showPagination: {
        type: Boolean,
        default: true,
    },
});

const emit = defineEmits(["sort-changed", "page-changed"]);

const visibleColumns = computed(() => {
    return props.columns.filter(column => column.visible !== false);
});

function onSort(field) {
    emit("sort-changed", field);
}

function onPageChange(url) {
    emit("page-changed", url);
}

function getSortingClass(field) {
    return props.sortingField === field ? "text-secondary me-3" : "text-dark me-3";
}
</script>
